<template>
  <!-- 平台 -->
  <div class="content-item white">
    <div class="content-items">
      <div class="image-list">
        <div class="image-item" v-for="(item, index) in imageList" :key="index" @click="exchange(index)" @mouseover="changeImage(index)" @mouseout="restoreImage(index)">
          <span :style="{ color: item.textColor }">{{ item.name }}</span>
          <img
            :src="item.image"
            :alt="item.name"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      imageList: [
        {
          image: require('../../assets/image/home/instant01.png'),
          image1: require('../../assets/image/home/instant02.png'),
          image2: require('../../assets/image/home/instant01.png'),
          url: 'https://cqdanghuan.com/static/index.html#/?channelId=0040963',
          name: 'Instant exchange',
          textColor: '#333'
        },
        {
          image: require('../../assets/image/home/deferred01.png'),
          image1: require('../../assets/image/home/deferred02.png'),
          image2: require('../../assets/image/home/deferred01.png'),
          url: 'https://www.xiaodangjingpai.com',
          name: 'Deferred Exchange',
          textColor: '#333'
        }
      ],
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
    changeImage(index) {
      this.imageList[index].image = this.imageList[index].image1;
      this.imageList[index].textColor = "#FF9600";
    },
    restoreImage(index) {
      this.imageList[index].image = this.imageList[index].image2;
      this.imageList[index].textColor = "#333";
    },
    exchange(index){
      if(index == 0){
        this.$router.push('/instantExchange');
      }else if(index == 1){
        this.$router.push('/deferredExchange');
      }
      
    }
  }
}
</script>

<style lang="less" scoped>
@media (max-width: 980px) {
  .home {
    width: 100%;
    // padding: 0 24px;
    box-sizing: border-box;
    .content-item {
      display: flex;
      flex-direction: column;
      padding: 0 24px;
      .content-items {
        padding-top: 55px;
        box-sizing: border-box;
        p {
          margin: 0;
          padding: 0;
          text-align: left;
          font-size: 32px;
          line-height: 32px;
        }
        .title {
          margin-bottom: 22px;
          font-size: 32px;
          line-height: 32px;
          color: #333;
          font-weight: 550;
        }
        .text {
          display: inline-block;
          color: #999;
          font-size: 24px;
          margin-bottom: 11px;
          text-align: left;
        }
        // .image-list {
        //   display: flex;
        //   justify-content: space-between;
        //   cursor: pointer;
        //   img {
        //     width: 160px;
        //     height: 135px;
        //   }
        //   span{
        //     width: 200px;
        //   }
        // }
        .image-list {
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          .image-item {
            width: 339px;
            height: 165px;
            position: relative;
            border-radius: 20px;
            border: 1px solid #D9D9D9;
            display: flex;
            align-items: center;
          }
          .image-item:hover{
            border-radius: 20px;
            border: 1px solid #FF9600;
            background: rgba(255, 150, 0, 0.08);
          }
          img {
            width: 160px;
            height: 135px;
            position: absolute;
            right: 0;
            bottom: 0;
          }
          span{
            margin-left: 32px;
            color: #333;
            font-family: "OPPOSans 2.14 NoVF";
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            width: 200px;
            text-align: left;
          }
        }
      }
    }
  }
}
@media (min-width: 981px) {
  .home {
    width: 100%;
    .main-content {
      width: 100%;
      .white {
        background: white;
      }
      .gray {
        background: #F6F6F6;
      }
      .content-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .content-items {
        width: 1200px;
        padding: 70px 0;
        box-sizing: border-box;
        .title {
          font-size: 36px;
          font-weight: 500;
          color: #111111;
          line-height: 36px;
          text-align: center;
          margin: 0;
        }
        .image-list {
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          .image-item {
            width: 588px;
            height: 165px;
            position: relative;
            border-radius: 20px;
            border: 1px solid #D9D9D9;
            display: flex;
            align-items: center;
          }
          .image-item:hover{
            border-radius: 20px;
            border: 1px solid #FF9600;
            background: rgba(255, 150, 0, 0.08);
          }
          img {
            width: 160px;
            height: 135px;
            position: absolute;
            right: 54px;
            bottom: 0;
          }
          span{
            margin-left: 54px;
            color: #333;
            font-family: "OPPOSans 2.14 NoVF";
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
